import apiClient from './api';

// Public contest API key (shared, intentionally client-exposed — the endpoint is public).
const CONTEST_API_KEY = 'k2j8x2mP9qL4nR7vT';

const contestService = {
    /**
     * Get the currently active contest, if any.
     * @returns {Promise<{ active: boolean, status: string, contest: object|null }>}
     */
    getActiveContest: async () => {
        // Pass the key as a query param (not a header) so the browser does not
        // fire a CORS preflight for a custom header — keeps this a simple GET.
        const response = await apiClient.get('/api/public/contest/active', {
            params: { api_key: CONTEST_API_KEY },
        });
        return response;
    },

    /**
     * Get the live top-100 leaderboard for the currently active contest.
     * @returns {Promise<{ leaderboard: Array<{ rank, name, point, address, district, thana, prevRank, prevPoint, avatar }> }>}
     */
    getLeaderboard: async () => {
        const response = await apiClient.get('/api/public/contest/leaderboard', {
            params: { api_key: CONTEST_API_KEY },
        });
        return response;
    },

    /**
     * The most recent contest with its details and — once final — the winners (top 50).
     * @returns {Promise<{ phase, contest, winnerCount, winners: Array }>}
     */
    getRecent: async () => {
        const response = await apiClient.get('/api/public/contest/recent', {
            params: { api_key: CONTEST_API_KEY },
        });
        return response;
    },

    /** Details of one contest (+ winners when final). */
    getDetails: async (id) => {
        const response = await apiClient.get(`/api/public/contest/${id}`, {
            params: { api_key: CONTEST_API_KEY },
        });
        return response;
    },

    // ── Logged-in "earn points" side (contest points are NOT credits) ──────────────────────

    /** My referral code, points breakdown, rank and claim statuses. */
    getMyPoints: async () => {
        const response = await apiClient.get('/api/contest/me');
        return response.data;
    },

    /** Claim a manual activity (share | fb_follow | fb_review | video_review) — once each. */
    claim: async ({ activity, proofUrl, note }) => {
        const response = await apiClient.post('/api/contest/claims', { activity, proofUrl: proofUrl || null, note: note || null });
        return response.data;
    },

    /** The daily quiz: today's questions for this owner (options in their own order — never the answers) + the progress summary. */
    getQuiz: async () => {
        const response = await apiClient.get('/api/contest/quiz');
        return response.data;
    },

    /** Answer one of today's questions → { correct, correctOptionId, points, quiz }. Once per question, ever (409 ALREADY_ANSWERED / QUIZ_DONE_TODAY). */
    answerQuiz: async ({ questionId, optionId }) => {
        const response = await apiClient.post('/api/contest/quiz/answer', { questionId, optionId });
        return response.data;
    },
};

export default contestService;
